export const InputAlphaOnly = {
  bind (el, binding) {
    el.addEventListener('input', (event) => {
      const inputValue = event.target.value
      const alphaRegex = /^[a-zA-Z ]+$/ // Regular expression to match only alphabetic characters.

      if (!alphaRegex.test(inputValue)) {
        // If the input contains non-alphabetic characters, remove them.
        event.target.value = inputValue.replace(/[^a-zA-Z ]/g, '')
      }
    })
  }
}
